// extracted by mini-css-extract-plugin
export default {"cta":"fI-z","disabled":"gI-z"};